import { useEffect } from "react";
import queryString from 'query-string';
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import { useRecoilState, useSetRecoilState, useResetRecoilState } from "recoil";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";
import { encryptJSON, decryptJSON, encryptString } from 'src/shared/global/cryptoJSUtilities';

const AgendarHoraEsp = () => {
    const query = queryString.parse(window.location.search)
    const [dayDefaultAvailable, setDayDefaultAvailable] = useRecoilState(dayDefaultAvailableState);
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
    const resetFilterSearchSelected = useResetRecoilState(filterSearchSelectedState);
    //const { loadDReservationCanceled, getDaysAvailable } = useSearchHours();
    const { loadDReservationCanceled, loadDaysAvailableAndDefault } = useSearchHours();
    
    useEffect(() => {
        (async function () {
            if (query.qec && query.qec !== "") {
                let splitted = window.location.search.split("qec=");
                const objDecryptJSON = decryptJSON(splitted[1]);
                setFilterSearchSelected((current) => ({
                    ...current,
                    specialitySelected: {
                        code: objDecryptJSON.code ,
                        value: objDecryptJSON.value ,
                        showInFilter: true,
                        canDeleteFilter: false
                    }
                }))

                setTimeout(() => {
                    loadDaysAvailableAndDefault()
                }, 0)

            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default AgendarHoraEsp